import { AboutBoxProps } from '../../../../components';
import { AppBranding } from '../../../../types/appBranding';
import { appBranding } from './Branding/Branding';
import React from 'react';
import StyledHeader, {
	Divider,
	LeftAlign,
	RightAlign,
	StyledLink,
} from './Header.styles';
import { HelpMenu } from './HelpMenu';
import { Logo } from './Logo/Logo';
import TenantPicker from './OrgSwitcher';
import StylovyzeNotification from './StylovyzeNotification';
import UserProfile from './UserProfile';
import {
	HeaderMenuOption,
	NotificationConfig,
	AUTHENTICATION_PROVIDER,
	AuthType,
} from '../../../../types';
import { useWeaveThemeContext } from '../../theme/WeaveContext';
import ProductPicker from '../../features/ProductPicker/ProductPicker';
import ProjectPicker from '../../features/ProjectPicker/ProjectPicker';
import { useIsFeatureEnabled } from '../../../../utils';
import useAppBranding from './useAppBranding';
export interface HeaderProps {
	branding: AppBranding;
	isTenantAware?: boolean;
	isLandingPage?: boolean;
	aboutBox?: Omit<AboutBoxProps, 'open' | 'setOpen'>;
	helpUrl?: string | false;
	hasLoginPicker?: boolean;
	inEmulation?: boolean;
	notificationConfig?: NotificationConfig;
	withHelpbot?: boolean;
	customHelpOptions?: HeaderMenuOption[];
	customProfileOptions?: HeaderMenuOption[];
}

export const Header = ({
	branding,
	isTenantAware = true,
	isLandingPage = false,
	helpUrl,
	aboutBox,
	hasLoginPicker = false,
	inEmulation = false,
	notificationConfig,
	withHelpbot,
	customHelpOptions,
	customProfileOptions,
}: HeaderProps) => {
	const notificationEnabled = !!notificationConfig;
	const _branding = useAppBranding(branding);
	const productPickerEnabled = useIsFeatureEnabled(
		'info-360-platform-product-picker',
	);
	// TODO find a better way to derive this value
	const isForge =
		localStorage.getItem(AUTHENTICATION_PROVIDER) == AuthType.Forge;

	const { isWeaveTheme, weaveThemeConsumer } = useWeaveThemeContext();
	const resolvedRoles = weaveThemeConsumer?.resolvedRoles;
	const backgroundColor =
		isWeaveTheme && resolvedRoles['menu.backgroundColor'];
	const textColor = isWeaveTheme && resolvedRoles['colorScheme.text.default'];

	const shouldDisplayTenantPicker =
		!isLandingPage &&
		isTenantAware &&
		((productPickerEnabled && !isForge) || !productPickerEnabled);

	return (
		<StyledHeader backgroundColor={backgroundColor} textColor={textColor}>
			<LeftAlign>
				{!isLandingPage && isForge && productPickerEnabled ? (
					<>
						<ProductPicker>
							<Logo {...appBranding[_branding]} />
						</ProductPicker>

						{isTenantAware && (
							<>
								<Divider />
								<ProjectPicker data-testing-id="org-switcher-button" />
							</>
						)}
					</>
				) : (
					<StyledLink to="/">
						<Logo {...appBranding[_branding]} />
					</StyledLink>
				)}
			</LeftAlign>
			<RightAlign data-cy="header-user-context">
				{shouldDisplayTenantPicker && (
					<TenantPicker data-testing-id="org-switcher-button" />
				)}
				{notificationEnabled && (
					<StylovyzeNotification
						config={{
							applicationId: notificationConfig.applicationId,
							userId: notificationConfig.userId,
							tenantId: notificationConfig.tenantId,
							product: notificationConfig.product,
						}}
					/>
				)}
				<HelpMenu
					helpUrl={helpUrl}
					withHelpBot={withHelpbot}
					customOptions={customHelpOptions}
				/>
				<UserProfile
					aboutBox={aboutBox}
					data-testing-id="user-profile-button"
					hasLoginPicker={hasLoginPicker}
					inEmulation={inEmulation}
					customProfileOptions={customProfileOptions}
				/>
			</RightAlign>
		</StyledHeader>
	);
};

export default Header;
